import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { BreadcrumbItem } from '@shared/ui-components/breadcrumbs/shared/breadcrumb-item';

@Component({
  selector: 'evland-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: [ './breadcrumbs.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    RouterLink,
    MatIcon,
  ]
})
export class BreadcrumbsComponent {
  items = input.required<BreadcrumbItem[]>();
}
